import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Policies from "@/pages/Policies";
import Upload from "@/pages/Upload";
import JournalEntries from "@/pages/JournalEntries";
import Activity from "@/pages/Activity";
import Reference from "@/pages/Reference";
import Users from "@/pages/Users";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route index element={<Dashboard />} />
                    <Route path="policies" element={<Policies />} />
                    <Route path="upload" element={<Upload />} />
                    <Route path="journal-entries" element={<JournalEntries />} />
                    <Route path="activity" element={<Activity />} />
                    <Route path="reference/:kind" element={<Reference />} />
                    <Route path="users" element={<Users />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
